import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dropdown } from 'react-bootstrap';
import cx from 'classnames';
import style from './PageListActions.scss';

const propTypes = {
  page: PropTypes.object.isRequired,
  actionName: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  asTopMenuOpt: PropTypes.bool,
  singleBtn: PropTypes.bool,
};

const defaultProps = {
  asTopMenuOpt: false,
};

const BasicAction = ({
  page, actionName, displayName, onClick, asTopMenuOpt, singleBtn,
}) => (asTopMenuOpt ? (
  <span className={style.topBtnWrapper}>
    <Button
      onClick={onClick({ actionName, currPage: page })}
      className={cx(style.topBtn, { [style.singleBtn]: singleBtn })}
    >
      {displayName}
    </Button>
  </span>
) : (
  <Dropdown.Item
    onClick={onClick({ actionName, currPage: page })}
    className={style.actionMenuItem}
  >
    {displayName}
  </Dropdown.Item>
));

BasicAction.propTypes = propTypes;
BasicAction.defaultProps = defaultProps;

export default BasicAction;
